var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom-pagination-container" }, [
    _c(
      "div",
      { staticClass: "pagination-left" },
      [
        _vm._t("footer-update"),
        _vm._v(" "),
        _vm._t("footer-list", function() {
          return [
            !_vm.countRight
              ? _c("span", { staticClass: "text-muted" }, [
                  _vm._v("Записей: "),
                  _c("b", [_vm._v(_vm._s(_vm.totalRows))])
                ])
              : _vm._e()
          ]
        })
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pagination-center" },
      [
        _vm._t("footer-pagination", function() {
          return [
            _vm.useRouter
              ? _c("b-pagination-nav", {
                  staticClass: "m-0 custom-pagination-nav",
                  attrs: {
                    "link-gen": _vm.linkGen,
                    "number-of-pages": _vm.numberOfPages,
                    "per-page": _vm.perPage,
                    value: _vm.currentPage
                  },
                  on: { "page-click": _vm.onPagination }
                })
              : _c("b-pagination", {
                  staticClass: "m-0 custom-pagination-nav",
                  attrs: {
                    "total-rows": _vm.totalRows,
                    "per-page": _vm.perPage,
                    value: _vm.currentPage
                  },
                  on: { input: _vm.onPaginationInput }
                })
          ]
        })
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pagination-right" },
      [
        _vm._t("count-right"),
        _vm._v(" "),
        _vm._t("footer-per-page", function() {
          return [
            _c("span", { staticClass: "text-muted" }, [
              _vm._v("Показывать по:")
            ]),
            _vm._v(" "),
            _c("b-form-select", {
              staticClass: "custom-per-page-select",
              attrs: { value: _vm.perPage, options: _vm.pageOptions },
              on: { change: _vm.onPerPageChange }
            })
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00d6124a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00d6124a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/utilites/commonUi/PaginationFooter.vue
// module id = null
// module chunks = 